// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"3053fa73","585":"d313f083"}[chunkId] + ".chunk.js";
};